// extracted by mini-css-extract-plugin
var _1 = "EjLnBQtSTIVYpiu4ZP4g";
export { _1 as "mention" }
